'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'scanner';
var width = 32;
var height = 32;
var ligatures = [];
var unicode = 'ff01';
var svgPathData = 'M30,21c0-0.1,0-0.2-0.1-0.3l-3.8-10.6l3.8-6.6c0.2-0.3,0.2-0.7,0-1C29.7,2.2,29.4,2,29,2H3C2.6,2,2.3,2.2,2.1,2.5 C2,2.8,2,3.2,2.1,3.5l3.8,6.6L2.1,20.7C2,20.8,2,20.9,2,21c0,0,0,0,0,0v6c0,1.7,1.3,3,3,3h22c1.7,0,3-1.3,3-3L30,21	C30,21,30,21,30,21z M25,26h-3c-0.6,0-1-0.4-1-1s0.4-1,1-1h3c0.6,0,1,0.4,1,1S25.6,26,25,26z M4.4,20l3.3-9h16.6l3.3,9H4.4z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faScanner = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
